/** @jsx jsx */
import React, { useCallback } from 'react';
import { jsx, css } from '@emotion/react';

const pillStyle = css`
    display: inline-flex;
    align-items: center;
    padding: 3px 12px;
    font-size: 0.74rem;
    font-weight: 500;
    border: 1px solid #ced4da;
    border-radius: 20px;
    background: #fff;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.15s;
    margin: 2px;
    &:hover { border-color: #007bff; color: #007bff; background: #f0f6ff; }
`;

const pillActiveStyle = css`
    ${pillStyle};
    background: #007bff;
    border-color: #007bff;
    color: #fff;
    &:hover { background: #0056b3; border-color: #0056b3; color: #fff; }
`;

const StatusFilter = ({ id, label, options, onChange, showAll = true, exclude = [] }) => {
    const isAllSelected = Object.values(options).every(v => !v.selected);

    const handleAllClick = useCallback(() => {
        const cleared = {};
        Object.keys(options).forEach(key => {
            cleared[key] = { ...options[key], selected: false };
        });
        onChange(cleared);
    }, [options, onChange]);

    const handleToggle = useCallback((key) => {
        onChange({ ...options, [key]: { ...options[key], selected: !options[key].selected } });
    }, [options, onChange]);

    return (
        <div className="d-flex align-items-center flex-wrap">
            {label && <small className="font-weight-bold text-muted mr-2">{label}</small>}
            {showAll && (
                <button type="button" css={isAllSelected ? pillActiveStyle : pillStyle} onClick={handleAllClick}>
                    All
                </button>
            )}
            {Object.entries(options).map(([key, val]) => {
                if (exclude.includes(key)) return null;
                return (
                    <button key={`${id}-${key}`} type="button"
                        css={val.selected ? pillActiveStyle : pillStyle}
                        onClick={() => handleToggle(key)}>
                        {val.text || key}
                    </button>
                );
            })}
        </div>
    );
};

export default React.memo(StatusFilter);
